import React, { useState } from "react";
import ApiLink from "../components/api/ApiLink";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function ForgotPassword() {
  const history = useHistory();
  const swal = require("sweetalert2");

  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    try {
      const response = await ApiLink.post("/api/forgot-password-reset-link", {
        email: email,
      });

      if (response.status === 200) {
        swal.fire({
          title: "A password reset link has been sent to your email.",
          icon: "success",
          toast: true,
          timer: 4000,
          position: "top-right",
          timerProgressBar: true,
          showConfirmButton: false,
        });
        history.push("/");
      }
    } catch (error) {
      swal.fire({
        title: "Something went wrong. Please try again later.",
        icon: "warning",
        toast: true,
        timer: 4000,
        position: "top-right",
        timerProgressBar: true,
        showConfirmButton: false,
      });
    } finally {
      setIsLoading(false); // Stop loading regardless of outcome
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 sm:px-6 lg:px-8 bg-gray-100">
      <div className="max-w-md w-full bg-white p-6 rounded-lg shadow-xl">
        {isLoading && (
          <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
            <div className="flex items-center justify-center">
              <svg
                className="animate-spin h-5 w-5 text-blue-600 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span className="text-blue-800 text-sm font-medium">
                Processing your request...
              </span>
            </div>
          </div>
        )}
        <h2 className="text-center text-2xl font-semibold text-gray-700">
          Forgot Password
        </h2>
        <p className="text-center text-sm text-gray-500">
          Please use your registered email!
        </p>
        <form onSubmit={handResetPassword} className="mt-6">
          <div>
            <label htmlFor="email" className="font-medium text-[#6a6c6f]">
              Email Address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              placeholder="user@domain.com"
              className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-green-200 focus:border-[#62CB31] focus:z-10 sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-75"
            />
          </div>
          <div className="mt-6">
            <button
              type="submit"
              disabled={isLoading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-md font-medium rounded-md text-white bg-[#62CB31] hover:bg-[#74D348] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#62CB31] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#62CB31] transition-all duration-200"
            >
              {isLoading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Processing...
                </>
              ) : (
                "Request Password Reset"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
